import { memo, useMemo } from "react";
import { getSecurityKey } from "../../util/security";
import { useSelector } from "react-redux";
import { selectSnapshot, selectSnapshots } from "../../selectors/security";
import { toLocaleStringIn } from "../../util/general";
import { GroupedPosition } from "../../reducer/positions.reducer";

export type LtpCellProps = {
    position: GroupedPosition
}

const LtpCell: React.FC<LtpCellProps> = ({position}) => {

    const { security, quantity } = position;
    const securityKey = getSecurityKey(security.exchange, security.code);
    const snapshots = useSelector(selectSnapshots);
    const snapshot = useSelector(selectSnapshot(securityKey))

    const basketLTP = useMemo(() => {
        if ( !snapshots || position.children?.length <= 1 || position.quantity === 0) return 0;
        return position.children?.reduce((sum, p) => {
            const snapshot = snapshots[getSecurityKey(p.security.exchange, p.security.code)];
            return sum + snapshot?.lastTradedPrice * p.quantity
        }, 0) || 0
    }, [position, snapshots])

    return <span>{ (quantity !== 0 && toLocaleStringIn(((position.children?.length > 1 ? Math.abs(basketLTP/quantity) : snapshot?.lastTradedPrice)??0)/(security.priceMultiplier??100)) || "-")}</span>;
}


export default memo(LtpCell);